module.exports = __webpack_public_path__ + "tremendous.png";